import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material'
import React, { useEffect, useState } from 'react'
import MonthlyReport from './MonthlyReport';
import RankingReport from './RankingReport';
import YTDReport from './YTDReport';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CategoryComparisionReport from './CategoryComparisionReport';

function StarRating() {
    const { starratingType } = useParams();
    const location = useLocation()
    const navigate = useNavigate()
    const pathValue = location.pathname.split("/").pop();
    const [alignment, setAlignment] = useState<string>(pathValue ?? '')


    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ) => {
        if (!newAlignment || newAlignment === alignment) return;
        newAlignment && setAlignment(newAlignment);
        navigate(`/maindashboard/starRating/${newAlignment}`)
    };

    useEffect(() => {
        navigate(`/maindashboard/starRating/${alignment}`)
    }, [alignment])

    const SelectedItem = () => {
        switch (starratingType) {
            case 'monthlyreport':
                return <MonthlyReport />;

            case 'ytdreport':
                return <YTDReport />;

            case 'rankingreport':
                return <RankingReport />;

        }
    }


    return (
        <Box className='h-100'>
            <Box className="selected togglebutton  d-flex justify-content-center mb-3">
                <ToggleButtonGroup
                    className="d-flex justify-content-start m-0 p-0"
                    exclusive
                    value={alignment}
                    onChange={handleChange}
                >
                    <ToggleButton className="py-2 px-3 m-0" value="monthlyreport">
                        Monthly Report
                    </ToggleButton>
                    <ToggleButton className="py-2 px-3 m-0" sx={{ whiteSpace: 'nowrap' }} value="rankingreport">
                        Ranking Report
                    </ToggleButton>
                    <ToggleButton className="py-2 px-3 m-0" sx={{ whiteSpace: 'nowrap' }} value="ytdreport">
                        YTD Report
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>

            <Box>
                {SelectedItem()}
            </Box>
        </Box>
    )
}

export default StarRating
